<dx-popup
   [width]="'500'"
   [height]="'600'"
   [showTitle]="true"
   title="Convalida DDT"
   [dragEnabled]="false"
   [hideOnOutsideClick]="false"
   [showCloseButton]="true"
   (onHiding)="chiudiModal()"
   [copyRootClassesToWrapper]="true"
   class="app-dx-dialog over-modal-wrapper"
   [(visible)]="popupVisible">


   <div class="app-dialog-wrapper">
      <div class="app-dialog-content">

         <form [formGroup]="convalidaFrm" class="p-4 form-modal">

            <div>
               <mat-label>Numero documento</mat-label>
               <mat-form-field class="block" appearance="fill">
                  <input matInput formControlName="n_ddt">
               </mat-form-field>
            </div>
            <!--            <mat-form-field class="block" appearance="fill">-->
            <!--               <mat-label>Data ricezione</mat-label>-->
            <!--               <input matInput [matDatepicker]="picker" formControlName="data_ricezione">-->
            <!--               <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
            <!--               <mat-datepicker #picker></mat-datepicker>-->
            <!--            </mat-form-field>-->

            <div class="mt-3">
               <mat-label>Data ricezione</mat-label>
               <mat-form-field class="block" appearance="fill">
                  <input matInput [matDatepicker]="picker" formControlName="data_ricezione">
                  <mat-hint>Inserire data nel seguente formato: GG/MM/AAAA</mat-hint>
                  <mat-datepicker #picker></mat-datepicker>
               </mat-form-field>
            </div>

            <div class="mt-7">
               <mat-label>Documento allegato</mat-label>
               <mat-form-field class="block mt-5" appearance="fill">
                  <ngx-mat-file-input #fileInput></ngx-mat-file-input>
                  <button mat-icon-button matSuffix *ngIf="!fileInput.empty" (click)="fileInput.clear($event)">
                     <mat-icon>clear</mat-icon>
                  </button>
               </mat-form-field>
            </div>

            <div class="mt-3">
               <mat-label>Note DDT</mat-label>
               <mat-form-field class="block" appearance="fill">
                  <textarea matInput placeholder="" formControlName="note"></textarea>
               </mat-form-field>
            </div>


         </form>

      </div>

      <div class="app-dialog-footer">
         <div>
            <button class="ds-btn ds-btn-info-outline h-full" (click)="chiudiModal()"
                    style="width: 50%">
               Annulla
            </button>
            <button class="ds-btn ds-btn-info h-full " [disabled]="!convalidaFrm.get('data_ricezione')"
                    style="width: 50%"
                    (click)="convalidaClick()">
               Salva
            </button>
         </div>
      </div>
   </div>

</dx-popup>
